export default "__VITE_ASSET__1DIRkuMt__"